<div class="feed">
    @for(ni of news; track ni.id) {
    <div class="item">
        <span class="date">{{ni.displayDate}}</span>
        <span class="text" [innerHTML]="ni.message"></span>
    </div>
    }
</div>